import {
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  Popover,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { File } from 'src/pages/vacancies/vacancies.interfaces';

import { DocumentContainer, FileWrapper, Layout } from './file-element.styles';

const FileElement = ({
  data,
  title,
  setFile,
}: {
  data: File[];
  title: string;
  setFile: (file: File) => void;
}) => {
  const [elementId, setElementId] = useState('');
  const { t } = useTranslation('vacancies');

  return (
    <DocumentContainer>
      <Typography weight="bold">{title}:</Typography>
      {elementId && <Layout onClick={() => setElementId('')} />}

      <div>
        {data.map(({ filename, _id, location }) => (
          <Popover
            key={_id}
            visible={_id === elementId}
            trigger="click"
            placement="right"
            onVisibleChange={() => setElementId(_id)}
            elements={[
              {
                label: t('buttons.previewDocument'),
                icon: ICONS.show,
                key: ICONS.show,
                handler: () => {
                  setFile({ filename, _id, location });
                  setElementId('');
                },
              },
              {
                label: t('buttons.download'),
                icon: ICONS.downvote,
                key: ICONS.downvote,
                handler: () => {
                  const a = document.createElement('a');
                  a.href = location;
                  a.click();
                  setElementId('');
                },
              },
            ]}
          >
            <FileWrapper>
              <div>
                <Icon icon={ICONS.paperclip} />
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.blue}>{filename}</Typography>
              </div>
              <Icon
                icon={ICONS.download}
                color={PLATFORM_THEME_COLORS.primary.blue}
                rightMargin={false}
                size={16}
              />
            </FileWrapper>
          </Popover>
        ))}
      </div>
    </DocumentContainer>
  );
};

export default FileElement;
